<template>
<div>
	<section>
		<div class="section-title">
                PROGRAMS
        </div>

        <div class="row">
        	<div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
                <div class="banner d-flex">
                	<router-link tag="a" :to="{ name : 'sme.courses.create' }" class="d-flex justify-content-center align-items-center green-content">
	                	<div class="caption">
		                	<div class="title">Add new program</div>
		                	<div class="subtitle"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_plus_circle_white.svg" width="40" /></div>
	                	</div><!--caption-->
                	</router-link>
                </div>
            </div><!--col-->
            
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex" v-for="course in courses">
                <div class="banner d-flex">
                	<router-link tag="a" :to="{ name : 'sme.courses.edit', params : { id : course.id } }" class="d-flex justify-content-center align-items-center">
                		<span class="status edit">{{ course.status }}</span>
	                	<div class="thumb-container" :style="{ 'background-image' : 'url('+course.image+')' }"></div>
	                	<div class="caption">
		                	<div class="title">{{ course.name }}</div>
		                	<div class="subtitle">{{ course.description }}</div>
	                	</div><!--caption-->
                	</router-link>
                </div>
            </div><!--col-->
            
             
        </div><!--row-->
	</section>
</div>
</template>

<script>
	export default{
		data : function(){
			return {
				courses : []
			}
		},

		created : function(){
			this.getCourses();
		},
		methods : {
			getCourses : function(){
				var params = {
					filters : {
						page : this.current_page
					}
				}
				
				this.$store.dispatch('getCourses', params).then((res) => {
					this.courses = res.data.data;

				}).catch((error) => {
					console.log(error);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/sme/courses/SMECourseListComponent.vue